import * as THREE from 'three'
import { useState, useMemo, useEffect } from 'react'
import { useThree, useLoader } from '@react-three/fiber'
import { useTexture, useGLTF, Float } from '@react-three/drei'
import { TextureLoader } from 'three/src/loaders/TextureLoader';
import Cookies from 'js-cookie'
const sizeIndex = {
  1 : 1,
  2 : 1,
  3 : 1
}
// const jewelCount = Cookies.get('jewelCounter') || 0
// const nextCount = parseInt(jewelCount) > 2 ? 1 : parseInt(jewelCount) + 1
// Cookies.set('jewelCounter', nextCount)
function randomIntFromInterval(min, max) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const nextCount = randomIntFromInterval(1, 3)
console.log(nextCount)
function Noodle() {
  const colorMap = useLoader(TextureLoader, "metal_seamless_texture.jpg");
  // const colorMap = useLoader(TextureLoader, "metal_seamless_texture_6718.jpg");
  // const colorMap = useLoader(TextureLoader, "testTexture.jpg");
  // const colorMap = useLoader(TextureLoader, "flower.jpg");
  colorMap.wrapS = THREE.RepeatWrapping;
  colorMap.wrapT = THREE.RepeatWrapping;

  colorMap.repeat.set(1, 1);

  const textures = useTexture([
    "/ao.jpg",
    "/normal.jpg",
    "/height.png",
    "/roughness.jpg",
    "/metal_seamless_texture.jpg",
    "/DisplacementMap.png",
    "/metal_seamless_texture_6718.jpg",
  ]);
  const [ao, normal, height, roughness, metalold, dpmap, metal] = textures;
  const { size, viewport, camera } = useThree()

  const { nodes } = useGLTF('/' + nextCount + '.glb')
  let [geometry] = useState(() => {
    return nodes[`my_project00${nextCount}`].geometry
  })
  
  const [speed] = useState(() => 0.1 + Math.random() / 10)
  const position = useMemo(() => {
    const z = Math.random() * -30
    const bounds = viewport.getCurrentViewport(camera, [0, 0, z])
    return [THREE.MathUtils.randFloatSpread(bounds.width), THREE.MathUtils.randFloatSpread(bounds.height * 0.75), z]
  }, [viewport])
  // const torus = new THREE.TorusKnotGeometry(10, 3, 100, 16);
  // geometry.setAttribute('uv', torus.getAttribute('uv'))
  return (
    <Float position={position} speed={speed} rotationIntensity={10} floatIntensity={40} dispose={null}>
      {/* <mesh scale={sizeIndex[nextCount] * .2} geometry={geometry}> */}
      <mesh scale={sizeIndex[nextCount] * 1.8} geometry={geometry}>
        {/* <planeBufferGeometry args={[1.2,1.2]} /> */}

        <meshPhysicalMaterial 
          metalness={1} // old: 1
          // roughness={0}
          roughness={0.20}
          color="#e0d0ab"
          emissive='#000'
          reflectivity={0.15199}
          clearcoat={0.11}
          clearcoatRoughness={0.27}
          radius={5}
          resolution={[size.width, size.height]}
          // aoMap={colorMap}
          // normalMap={colorMap}
          normalScale={[1, 1]}
          // displacementMap={dpmap}
          displacement={0.2}
          // envMap={colorMap}
          // envMapIntensity={.2}
          // roughnessMap={colorMap}
          map={colorMap}
          // diffuseMap={colorMap}
        />
      </mesh>
    </Float>
  )
}

export default function Noodles() {
  let amount;
  if (window.innerWidth < 600) amount = 10
  else if (window.innerWidth >= 600 && window.innerWidth <= 1200) amount = 14
  else amount = 16

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })
  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })

    }
    window.addEventListener('resize', handleResize)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return Array.from({ length: amount }, (_, i) => <Noodle key={i} />)
}

useGLTF.preload('/jewelry.glb')
